(function(){
var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

function initFaq(scope){
  scope.querySelectorAll('[data-rwn-faq] .faq-item').forEach(function(item){
    if(item.dataset.rwnInit) return; item.dataset.rwnInit = '1';
    var q = item.querySelector('.faq-q'); if(!q) return;
    q.addEventListener('click', function(){
      var open = item.classList.toggle('open');
      q.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });
}
function initUgc(scope){
  scope.querySelectorAll('[data-rwn-ugc]').forEach(function(row){
    if(row.dataset.rwnInit) return; row.dataset.rwnInit = '1';
    var dotsWrap = row.parentNode.querySelector('[data-rwn-ugc-dots]'); if(!dotsWrap) return;
    var cards = row.querySelectorAll('.uv');
    dotsWrap.innerHTML = '';
    cards.forEach(function(c, i){
      var b = document.createElement('button'); b.type = 'button';
      b.setAttribute('aria-label', 'Go to video ' + (i + 1));
      b.addEventListener('click', function(){ c.scrollIntoView({behavior: REDUCED ? 'auto' : 'smooth', inline: 'center', block: 'nearest'}); });
      dotsWrap.appendChild(b);
    });
    var dots = dotsWrap.querySelectorAll('button');
    function syncDots(){
      var mid = row.scrollLeft + row.clientWidth / 2, best = 0, bd = Infinity;
      cards.forEach(function(c, i){ var d = Math.abs(c.offsetLeft + c.offsetWidth / 2 - mid); if(d < bd){ bd = d; best = i; } });
      dots.forEach(function(d, i){ d.classList.toggle('on', i === best); });
    }
    row.addEventListener('scroll', syncDots, {passive: true}); syncDots();
    var down = false, startX = 0, startL = 0;
    row.addEventListener('mousedown', function(e){ down = true; startX = e.pageX; startL = row.scrollLeft; row.classList.add('dragging'); });
    window.addEventListener('mousemove', function(e){ if(!down) return; row.scrollLeft = startL - (e.pageX - startX); });
    window.addEventListener('mouseup', function(){ down = false; row.classList.remove('dragging'); });
  });
}
function initPhotoloop(scope){
  scope.querySelectorAll('[data-rwn-photoloop]').forEach(function(loop){
    if(loop.dataset.rwnInit) return; loop.dataset.rwnInit = '1';
    loop.innerHTML += loop.innerHTML;
  });
}
function initSticky(scope){
  scope.querySelectorAll('[data-rwn-sticky]').forEach(function(bar){
    if(bar.dataset.rwnInit) return; bar.dataset.rwnInit = '1';
    function sync(){
      var hero = document.querySelector('[data-rwn-hero-cta]');
      var passed = hero ? hero.getBoundingClientRect().bottom < 0 : window.scrollY > 600;
      var drawer = document.querySelector('.menu-drawer[open], details[open] > .menu-drawer, #mNav.show');
      bar.classList.toggle('show', window.innerWidth <= 900 && passed && !drawer);
    }
    window.addEventListener('scroll', sync, {passive: true}); window.addEventListener('resize', sync); sync();
  });
}
function initKits(scope){
  scope.querySelectorAll('.rwn-home .kit').forEach(function(card){
    if(card.dataset.rwnInit) return; card.dataset.rwnInit = '1';
    var sel = card.querySelector('[data-balm]'), cta = card.querySelector('.kit-cta');
    if(!sel || !cta) return;
    function sync(){
      var base = cta.dataset.url || ('/products/' + cta.dataset.handle);
      cta.dataset.balmVariant = sel.value;
      cta.href = base + '?plan=sub&variant=' + encodeURIComponent(sel.value);
    }
    sel.addEventListener('change', sync); sync();
  });
}

function initShop(root){
  if(!root || root.dataset.rwnInit) return; root.dataset.rwnInit = '1';
var $ = function(sel){ return root.querySelector(sel); };
var $$ = function(sel){ return Array.prototype.slice.call(root.querySelectorAll(sel)); };

var SELLING_PLAN = Number(root.dataset.sellingPlan) || null;
function openCart(){
  try{
    if(typeof window.SLIDECART_OPEN === 'function'){
      window.dispatchEvent(new CustomEvent('ocu:cart:open:updated', {detail:{triggerElement: document.activeElement}}));
    } else {
      location.href = '/cart';
    }
  }catch(e){}
}
function flash(btn, text){
  if(!btn) return;
  var span = btn.querySelector('span') || btn, orig = span.textContent;
  span.textContent = text; setTimeout(function(){ span.textContent = orig; }, 2200);
}
function add(items, btn, fallbackHref){
  var needsPlan = items.some(function(i){ return i.selling_plan === 'PATRIOT'; });
  if(needsPlan && !SELLING_PLAN){
    flash(btn, 'Setup needed');
    console.warn('[RWN] Patriot Rate selling plan is not set on the Shop All section. Refusing to add a subscription as a one-time item.');
    return Promise.resolve(false);
  }
  items.forEach(function(i){ if(i.selling_plan === 'PATRIOT') i.selling_plan = SELLING_PLAN; });
  return fetch('/cart/add.js', {method:'POST', credentials:'same-origin',
      headers:{'Content-Type':'application/json'}, body: JSON.stringify({items: items})})
    .then(function(r){ return r.json().then(function(body){
      if(!r.ok) throw new Error(body && body.description ? body.description : 'Could not add to cart');
      flash(btn, 'Added ✓'); openCart();
      try{ document.dispatchEvent(new CustomEvent('cart:refresh')); }catch(e){}
      return true; }); })
    .catch(function(err){
      console.warn('[RWN] cart add failed:', err && err.message);
      if(fallbackHref) location.href = fallbackHref; else flash(btn, 'Try again');
      return false;
    });
}

var DISPLAY = {"build-your-box-parent":{"t":"Build Your Own Box","note":"Pick 4 to 20 bars"},"the-tallow-reserve-beef-tallow-soap-set":{"t":"The Tallow Reserve","note":"5 bars + Balm of the Brave"},"the-old-guard-mens-soap-set":{"t":"The Old Guard","note":"5 bars + Balm of the Brave"},"the-timberline-mens-soap-set":{"t":"The Timberline","note":"5 bars + Balm of the Brave"},"the-frontiersman":{"t":"The Frontiersman 4-Pack","note":"4 bars"},"the-outdoorsman":{"t":"The Outdoorsman 4-Pack","note":"4 bars"},"the-macho-man":{"t":"The Macho Man 4-Pack","note":"4 bars"},"the-gentleman":{"t":"The Gentleman 4-Pack","note":"4 bars"},"the-classic-man":{"t":"The Classic Man 4-Pack","note":"4 bars"},"his-n-hers-5-pack-1":{"t":"His-N-Hers 5-Pack","note":"5 bars"},"natty-right-9-pack":{"t":"Natty Right 9-Pack","note":"9 bars"},"the-patriot-pack":{"t":"The Patriot Pack 13 Bars","note":"13 bars"},"the-full-salute":{"t":"The Full Salute 18 Bars","note":"18 bars + Balm of the Brave"},"the-ultimate-tallow-bundle-2":{"t":"The Ultimate Tallow Bundle","note":"7 bars + Balm of the Brave"},"the-family-pack-1":{"t":"The Family Pack 26 Bars","note":"26 bars"},"balm-of-the-brave":{"t":"Balm of the Brave","note":"100% American Grass Fed Tallow Balm"},"lady-liberty-gift-box":{"t":"Lady Liberty Gift Box","note":"Gift box"},"breck-barrel-bourbon":{"t":"Breck Barrel Bourbon"},"orange-man-grit":{"t":"Orange Man Grit"},"maru-fountain-falls":{"t":"Maru Fountain Falls"},"sweet-sawmill-timber":{"t":"Sweet Sawmill Timber"},"oakmont-air":{"t":"Oakmont Air"},"bryson-wood":{"t":"Bryson Woods"},"frankisexy":{"t":"Frankinsexy"},"dark-horse":{"t":"Dark Horse"},"kingdom-of-the-west":{"t":"Kingdom of the West"},"pine-pilsner":{"t":"Pine & Pilsner"},"freshly-minted":{"t":"Freshly Minted"},"cedar-gone":{"t":"Cedar Gone Wild"},"mango-ipa":{"t":"Mango IPA"},"sweet-cherry-pie-1":{"t":"Sweet Cherry Pie"},"razzle-dazzle":{"t":"Razzle Dazzle"},"utterly-oats":{"t":"Utterly Oats"},"merican-meringue":{"t":"'Merican Meringue"},"peppermint-trail":{"t":"Peppermint Trail"},"250-proof":{"t":"250 Proof"}};
var LIVE = [];
try{ LIVE = JSON.parse(document.getElementById('rwn-shop-live').textContent); }catch(e){ console.warn('[RWN] live product JSON failed to parse', e); }
var inColl = {}; LIVE.forEach(function(l){ if(!l.k) inColl[l.h] = 1; });
var ORDERED = LIVE.filter(function(l){ return l.k && !inColl[l.h]; }).concat(LIVE.filter(function(l){ return !l.k; }));

var GRIT_KEY = {'smooth':'smooth', 'no grit':'smooth', 'moderate':'moderate', 'moderate grit':'moderate', 'heavy':'heavy', 'heavy grit':'heavy', 'grittiest':'heavy', 'light':'light'};
var GRIT_NAME = {smooth:'No Grit', moderate:'Moderate Grit', heavy:'Grittiest', light:'Light'};
function gritKey(v){ return GRIT_KEY[String(v == null ? '' : v).trim().toLowerCase()] || null; }
function titleCase(s){ return String(s || '').toLowerCase().replace(/(^|[\s\-'&])([a-z])/g, function(m, a, b){ return a + b.toUpperCase(); }); }
function inCol(live, h){ return (live.cs || []).indexOf(h) >= 0; }
var BAR = LIVE.filter(function(l){ return inCol(l, 'soaps') && l.p > 0; }).reduce(function(m, l){ return Math.min(m, l.p); }, Infinity);
if(!isFinite(BAR)) BAR = 0;
var PRODUCTS = ORDERED.map(function(live, i){ return build(live, i); });
function build(live, i){
  var d = DISPLAY[live.h] || {}, p = {};
  p.h = live.h; p.feat = i;
  p.t = d.t || titleCase(String(live.t).replace(/\s+[—–-]\s+.*$/, ''));
  p.note = d.note || '';
  p.kit = !!live.k || (live.tags || []).indexOf('starter-kit') >= 0;
  p.cat = (p.kit || inCol(live, 'multi-packs')) ? 'bundle' : inCol(live, 'soaps') ? 'single' : 'other';
  p.inTallow = inCol(live, 'tallow-products');
  p.v = live.v; p.url = live.url; p.img = live.img; p.p = live.p; p.cmp = live.cmp;
  p.byob = live.h === 'build-your-box-parent';
  if(p.byob) p.p = BAR;
  p.out = !live.av; p.ra = Number(live.ra) || 0; p.rc = Number(live.rc) || 0;
  p.r = Math.round(p.p * 80) / 100;
  p.tallow = live.tl === true || live.tl === 'true';
  p.grit = gritKey(live.gr);
  p.scent = pick(live.sc, ['woodsy', 'sweet', 'citrus', 'fresh']);
  p.badge = pick(live.bd, ['new', 'limited edition', 'gift box']);
  p.sub = p.cat !== 'single' && p.badge !== 'gift box';
  return p;
}
function pick(v, ok){
  v = String(v == null ? '' : v).trim().toLowerCase();
  return ok.indexOf(v) >= 0 ? v : null;
}

var STAR = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="m12 3 2.6 5.5 6 .8-4.4 4.2 1.1 6-5.3-2.9L6.7 19.5l1.1-6L3.4 9.3l6-.8L12 3Z"/></svg>';
var BYOB = root.dataset.byob || '#';
var cat = 'all', scent = 'all', grit = 'all', sort = 'feat';
var fmt = function(n){ return '$' + Number(n).toFixed(2); };
function esc(s){ return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/"/g,'&quot;'); }

function matches(p){
  if(cat === 'kit' && !p.kit) return false;
  if(cat === 'bundle' && p.cat !== 'bundle') return false;
  if(cat === 'single' && p.cat !== 'single') return false;
  if(cat === 'tallow' && !p.inTallow) return false;
  if(cat === 'single'){
    if(scent !== 'all' && p.scent !== scent) return false;
    if(grit !== 'all' && p.grit !== grit) return false;
  }
  return true;
}
function badge(p){
  if(p.out) return '<span class="badge out">Sold Out</span>';
  if(p.kit) return '<span class="badge kit">Starter Kit</span>';
  if(p.badge === 'new') return '<span class="badge new">New</span>';
  if(p.badge === 'limited edition') return '<span class="badge limited">Limited Edition</span>';
  if(p.badge === 'gift box') return '<span class="badge limited">Gift Box</span>';
  return '';
}
function priceBlock(p){
  if(p.byob && !p.out && p.p > 0){
    var bsave = Math.round((1 - p.r / p.p) * 100);
    return '<div class="pblock">'
      + '<div class="p1"><span class="lab">One time</span><span class="amt">' + fmt(p.p) + ' a bar</span></div>'
      + '<div class="p2"><span class="lab">The Patriot Rate</span><span class="amt">' + fmt(p.r) + ' a bar</span><span class="sv">SAVE ' + bsave + '%</span></div></div>';
  }
  if(p.out) return '<div class="ponly"><span class="amt">' + fmt(p.p) + '</span></div>';
  if(p.sub){
    var save = Math.round((1 - p.r / p.p) * 100);
    return '<div class="pblock">'
      + '<div class="p1"><span class="lab">One time</span><span class="amt">' + fmt(p.p) + '</span></div>'
      + '<div class="p2"><span class="lab">The Patriot Rate</span><span class="amt">' + fmt(p.r) + '</span>'
      + '<span class="sv">SAVE ' + save + '%</span></div></div>';
  }
  return '<div class="ponly"><span class="amt">' + fmt(p.p) + '</span><span class="lab">one time</span></div>';
}
function stars(p){
  if(!p.rc) return '<div class="rstars sm" data-review-handle="' + esc(p.h) + '"><span class="rc dim">No reviews yet</span></div>';
  var five = STAR + STAR + STAR + STAR + STAR, pct = Math.round(p.ra / 5 * 100);
  return '<div class="rstars sm" data-review-handle="' + esc(p.h) + '" aria-label="Rated ' + p.ra + ' out of 5 from ' + p.rc + ' reviews">'
    + '<span class="srow"><span class="sbg">' + five + '</span><span class="sfg" style="width:' + pct + '%">' + five + '</span></span>'
    + '<b>' + p.ra.toFixed(1) + '</b><span class="rc">(' + p.rc + ')</span></div>';
}
function meta(p){
  if(p.cat === 'single'){
    if(!p.grit) return '';
    var g = GRIT_NAME[p.grit];
    return '<div class="meta"><span class="glab">Grit Level:</span> ' + g + '</div>';
  }
  return p.note ? '<div class="meta">' + esc(p.note) + '</div>' : '';
}
function render(){
  var list = PRODUCTS.filter(matches);
  if(sort === 'plow') list = list.slice().sort(function(a,b){ return a.p - b.p; });
  else if(sort === 'phigh') list = list.slice().sort(function(a,b){ return b.p - a.p; });
  else list = list.slice().sort(function(a,b){ return (a.feat==null?99:a.feat) - (b.feat==null?99:b.feat); });

  $('#rwn-grid').innerHTML = list.map(function(p, i){
    var t = esc(p.t), u = esc(p.url);
    return '<div class="card ' + (p.kit ? 'kit ' : '') + (p.out ? 'soldout' : '') + '">'
      + '<a class="imglink" href="' + u + '" aria-label="' + t + '">'
      + '<div class="imgbox">' + badge(p) + (p.tallow ? '<span class="tbadge">Tallow</span>' : '')
      + (p.img ? '<img src="' + esc(p.img) + '" alt="' + t + '" width="800" height="800" ' + (i < 4 ? 'loading="eager" fetchpriority="high"' : 'loading="lazy"') + '>' : '')
      + '</div></a>'
      + '<div class="body">'
      + '<a class="tlink" href="' + u + '"><h3>' + t + '</h3></a>'
      + stars(p) + meta(p)
      + (p.out ? '<div class="soldnote">Sold Out &middot; Gone For Now</div>' : '')
      + priceBlock(p)
      + (p.out
          ? '<button class="atc" disabled type="button">Sold Out</button>'
          : (p.kit || p.sub)
            ? '<a class="atc gold sublink" href="' + u + '?plan=sub"><span>' + (p.byob ? 'Build Your Box' : 'Choose Your Option') + '</span></a>'
            : '<button class="atc" type="button" data-variant="' + p.v + '" data-url="' + u + '"><span>Add To Cart</span></button>')
      + (p.cat === 'single' && !p.out && BYOB !== '#'
          ? '<a class="bblink" href="' + esc(BYOB) + '?add=' + p.v + '">Build A Bundle &rarr;</a>' : '')
      + '</div></div>';
  }).join('');

  $('#rwn-count').textContent = list.length + (list.length === 1 ? ' product' : ' products');
  $('#rwn-empty').classList.toggle('show', list.length === 0);
  $('#rwn-subfilters').classList.toggle('show', cat === 'single');
}
function counts(){
  var c = {
    all: PRODUCTS.length,
    kit: PRODUCTS.filter(function(p){ return p.kit; }).length,
    bundle: PRODUCTS.filter(function(p){ return p.cat === 'bundle'; }).length,
    tallow: PRODUCTS.filter(function(p){ return p.inTallow; }).length,
    single: PRODUCTS.filter(function(p){ return p.cat === 'single'; }).length
  };
  $$('.tab .n').forEach(function(el){ el.textContent = '(' + c[el.dataset.count] + ')'; });
  var kitTab = $('.tab[data-cat="kit"]'); if(kitTab) kitTab.classList.toggle('hide', c.kit === 0);
}
$$('.tab').forEach(function(t){
  t.addEventListener('click', function(){
    cat = t.dataset.cat;
    $$('.tab').forEach(function(x){ x.classList.toggle('on', x === t); x.setAttribute('aria-pressed', x === t ? 'true' : 'false'); });
    if(cat !== 'single'){ scent = 'all'; grit = 'all';
      $$('[data-scent]').forEach(function(x){ x.classList.toggle('on', x.dataset.scent === 'all'); });
      $$('[data-grit]').forEach(function(x){ x.classList.toggle('on', x.dataset.grit === 'all'); });
    }
    render();
  });
});
$$('[data-scent]').forEach(function(c){
  c.addEventListener('click', function(){ scent = c.dataset.scent;
    $$('[data-scent]').forEach(function(x){ x.classList.toggle('on', x === c); }); render(); });
});
$$('[data-grit]').forEach(function(c){
  c.addEventListener('click', function(){ grit = c.dataset.grit;
    $$('[data-grit]').forEach(function(x){ x.classList.toggle('on', x === c); }); render(); });
});
$('#rwn-sort').addEventListener('change', function(e){ sort = e.target.value; render(); });

function setBarTop(){
  var top = 0;
  var hdr = document.querySelector('.shopify-section-group-header-group, #shopify-section-header, .section-header');
  if(hdr){
    var pos = getComputedStyle(hdr).position;
    if(pos === 'sticky' || pos === 'fixed') top = hdr.getBoundingClientRect().height;
  }
  $('#rwn-filterbar').style.top = top + 'px';
}
window.addEventListener('resize', setBarTop);
window.addEventListener('scroll', setBarTop, {passive:true});

$('#rwn-grid').addEventListener('click', function(e){
  var btn = e.target.closest('.atc:not(.sublink)');
  if(!btn || btn.disabled || !btn.dataset.variant) return;
  add([{id: Number(btn.dataset.variant), quantity: 1}], btn, btn.dataset.url);
});

function fromHash(){
  var hsh = (location.hash || '').replace('#','');
  if(!hsh){ var mt = /[?&]tab=([a-z]+)/i.exec(location.search); if(mt) hsh = mt[1].toLowerCase(); }
  var map = {kits:'kit', kit:'kit', bundles:'bundle', bundle:'bundle', packs:'bundle', tallow:'tallow', singles:'single', single:'single', bars:'single', all:'all'};
  var want = map[hsh]; if(!want) return false;
  var tab = $('.tab[data-cat="' + want + '"]'); if(tab){ tab.click(); return true; } return false;
}
window.addEventListener('hashchange', fromHash);
counts(); render(); setBarTop(); fromHash();
}

function initAll(scope){
  scope = scope || document;
  initFaq(scope); initUgc(scope); initPhotoloop(scope); initSticky(scope); initKits(scope);
  scope.querySelectorAll('[data-rwn-shop]').forEach(initShop);
  if(scope.matches && scope.matches('[data-rwn-shop]')) initShop(scope);
}
if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ initAll(document); });
else initAll(document);
document.addEventListener('shopify:section:load', function(e){ initAll(e.target); });
})();
